<template>
  <job-status
    :job-id="postImport.jobId"
    v-model="jobRun"
    v-slot="{ isPending, isRunning, success, failure }"
    style="font-size: 1.25rem"
  >
    <q-icon v-if="isPending || isRunning" name="fa fa-spinner fa-spin" />
    <q-icon
      v-else-if="failure"
      name="fa fa-exclamation-circle"
      color="negative"
      title="Import failed."
    />
    <q-icon v-else-if="success" name="fa fa-check-circle" color="green-4" />
    <q-icon v-else name="fa fa-spinner fa-spin" />
  </job-status>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import JobStatus from '@/monitor/job/JobStatus.vue';
import { PostImport } from '@/social/types';
import { JobRun } from '@/type';

interface Data {
  jobRun: JobRun|null
}

export default defineComponent({
  components: { JobStatus },
  props: {
    postImport: {
      type: Object as () => PostImport,
      required: true,
    },
  },
  data(): Data {
    return {
      jobRun: null,
    };
  },
});
</script>
